"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.initialState = void 0;
var _sources = require("@studio/sources");
var _types = require("../../actions/types");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var initialState = exports.initialState = ['SCENE_LAYER'];
function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
    payload = action.payload,
    _action$sceneLayerSou = action.sceneLayerSources,
    sceneLayerSources = _action$sceneLayerSou === void 0 ? {} : _action$sceneLayerSou;
  if (["".concat(_types.GET_BROADCAST, "_SUCCESS"), "".concat(_types.BROADCAST_SET_PROGRAM, "_SUCCESS"), "".concat(_types.BROADCAST_SYNC_LAYER_SOURCES, "_SUCCESS")].includes(type)) {
    var globalSceneLayers = payload.globalSceneLayers;
    return globalSceneLayers.length ? globalSceneLayers : state;
  }
  if (type === _types.BROADCAST_SET_PROGRAM) {
    return sceneLayersBasedOnProgram(payload, sceneLayerSources);
  }
  if ([_types.BROADCAST_SET_SCENE_LAYERS, "".concat(_types.BROADCAST_UPDATE_SCENE_LAYERS, "_SUCCESS")].includes(type)) {
    return payload || state;
  }
  return state;
}

/**
 * payload is program with animations applied
 */
function sceneLayersBasedOnProgram(scene, sceneLayerSources) {
  var layers = scene.layers,
    style = scene.style;
  var _sceneLayerSources$ov = sceneLayerSources.overlays,
    overlays = _sceneLayerSources$ov === void 0 ? [] : _sceneLayerSources$ov,
    _sceneLayerSources$ba = sceneLayerSources.backgrounds,
    backgrounds = _sceneLayerSources$ba === void 0 ? [] : _sceneLayerSources$ba;
  var liveBackgroundId = style === null || style === void 0 ? void 0 : style.backgroundId;
  var nextState = initialState;
  // The image layers contain all image source types - overlays + image sources
  var imageLayers = layers === null || layers === void 0 ? void 0 : layers.filter(function (item) {
    return (0, _sources.isImageSource)(item === null || item === void 0 ? void 0 : item.source);
  });
  var sceneBackground = backgrounds === null || backgrounds === void 0 ? void 0 : backgrounds.find(function (b) {
    return b._id === liveBackgroundId;
  });
  var sceneOverlays = overlays === null || overlays === void 0 ? void 0 : overlays.filter(function (o) {
    return !!imageLayers.find(function (l) {
      return l._id === o._id;
    });
  });
  if (sceneBackground) {
    sceneBackground.source.hidden = false;
    nextState = [sceneBackground].concat(_toConsumableArray(nextState));
  }
  if (sceneOverlays.length) {
    nextState = [].concat(_toConsumableArray(nextState), _toConsumableArray(sceneOverlays));
  }
  return nextState;
}